import React, { useState } from 'react';

import { noop } from 'lodash';
import { useIntl } from 'react-intl';

import Dialog from 'components/dialog';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { OkayDialogButton, StyledBodyDialog, TextDialog } from './styled';

interface IModalBlockRegion {
  show: boolean;
}

export const ModalBlockRegion: React.FC<IModalBlockRegion> = ({ show }) => {
  const { formatMessage } = useIntl();
  const [block, setBlock] = useState(true);
  const enableBlockByRegion = useFlag(LaunchDarklyFlag.ENABLE_BLOCK_BY_REGION);

  const handleConfirm = () => {
    setBlock(false);
  };

  return (
    <>
      {block && show && enableBlockByRegion && (
        <Dialog
          aria-label={formatMessage({ id: 'blockRegionMessage' })}
          bodyComponent={
            <StyledBodyDialog>
              <TextDialog>{formatMessage({ id: 'blockRegionMessage' })}</TextDialog>
              <OkayDialogButton
                onClick={handleConfirm}
                aria-label={formatMessage({ id: 'okay' })}
                data-testid="okay-modal-button"
              >
                {formatMessage({ id: 'okay' })}
              </OkayDialogButton>
            </StyledBodyDialog>
          }
          onDismiss={noop}
          modalAppearanceEventMessage={'enableBlockSignIn'}
          data-testid="block-dialog"
        />
      )}
    </>
  );
};
